<div
  class="label"
  data-cy="dashboard-custom-groups.header">
  {{ 'Groups' | translate }}
</div>
